import React from 'react'
import PropTypes from 'prop-types'
import i18n from 'i18next'
import {routeHelper} from '#config/routeKeys'
import {useAusbildungsplan} from '#hooks/useAusbildungsplan'
import {useChapterStatuses} from '#hooks/store/useChapterStatuses'
import MenuItem from '../MenuItem'
import {usePermissions} from '#hooks/usePermissions'

function AusbildungsplanCategories(props) {
  const {chapters, currentItem, contextualUserId} = props
  const {ready, findChildren} = useAusbildungsplan(contextualUserId)
  const {getSubmittedChapters, getConfirmedChapters} = useChapterStatuses(contextualUserId)
  const permissions = usePermissions()
  if (!ready) {
    return null
  }

  const submittedChapters = getSubmittedChapters(contextualUserId)
  const confirmedChapters = getConfirmedChapters(contextualUserId)

  const getFirstAvailableQuestionSet = children => {
    if (permissions.ausbildungsplan.edit) {
      return children[0]
    }
    if (permissions.ausbildungsplan.verify) {
      const first = children.find(x => submittedChapters.some(y => y.id === x.id))
      return first ? first : children[0]
    }
    if (permissions.ausbildungsplan.viewConfirmed) {
      const first = children.find(x => confirmedChapters.some(y => y.id === x.id))
      return first ? first : children[0]
    }
    return children[0]
  }

  return (
    <div data-menu="categories">
      <h3 className="menu__item--headline">{i18n.t('ausbildungsplan_submenu_general_assignment')}</h3>

      <ul className="menu__level">
        {chapters.map((chapter, index) => {
          const children = findChildren(chapter.id)
          const firstAvailableQuestionSet = getFirstAvailableQuestionSet(children)

          if (firstAvailableQuestionSet === null) {
            return null
          }

          const hasSubmittedChapter = children.some(x =>
            submittedChapters.some(y => y.id === x.id && y.status === 'submitted'),
          )

          const url = routeHelper.ausbildungsplanQuestionsChapter(contextualUserId, firstAvailableQuestionSet.id)
          return (
            <li key={chapter.id + '-' + index} className="menu__item">
              <MenuItem
                text={chapter.text}
                lead={chapter.lead}
                active={currentItem === chapter.id}
                url={url}
                disabled={false}
                hasSubmittedChapter={hasSubmittedChapter}
              />
            </li>
          )
        })}
      </ul>
    </div>
  )
}

AusbildungsplanCategories.propTypes = {
  currentItem: PropTypes.string,
  contextualUserId: PropTypes.number.isRequired,
  chapters: PropTypes.arrayOf(PropTypes.shape({id: PropTypes.string})),
}

export default AusbildungsplanCategories
